export const AI_ASSISTANT_WIDTH_STORAGE_KEY = 'unify.aiAssistant.drawerWidth';

export const AI_ASSISTANT_DEFAULT_WIDTH = 430;
export const AI_ASSISTANT_MIN_WIDTH = 340;
export const AI_ASSISTANT_MAX_WIDTH = 720;
export const AI_ASSISTANT_MAX_RATIO = 0.55;

/** Matches App.tsx mobile shell breakpoint (Mantine sm / 48em). */
export const AI_ASSISTANT_MOBILE_MEDIA_QUERY = '(max-width: 48em)';

export function clampAssistantWidth(width: number, availableMainWidth: number): number {
  const maxByRatio = Math.floor(availableMainWidth * AI_ASSISTANT_MAX_RATIO);
  const max = Math.max(
    AI_ASSISTANT_MIN_WIDTH,
    Math.min(AI_ASSISTANT_MAX_WIDTH, maxByRatio || AI_ASSISTANT_MAX_WIDTH),
  );
  return Math.min(max, Math.max(AI_ASSISTANT_MIN_WIDTH, Math.round(width)));
}

export function readStoredAssistantWidth(): number {
  try {
    const raw = window.localStorage.getItem(AI_ASSISTANT_WIDTH_STORAGE_KEY);
    if (!raw) return AI_ASSISTANT_DEFAULT_WIDTH;
    const parsed = Number(raw);
    if (!Number.isFinite(parsed)) return AI_ASSISTANT_DEFAULT_WIDTH;
    return clampAssistantWidth(parsed, Number.POSITIVE_INFINITY);
  } catch {
    return AI_ASSISTANT_DEFAULT_WIDTH;
  }
}

export function persistAssistantWidth(width: number): void {
  try {
    window.localStorage.setItem(AI_ASSISTANT_WIDTH_STORAGE_KEY, String(Math.round(width)));
  } catch {
    // Ignore quota / private-mode failures; width stays in memory.
  }
}
